var exports = {
  "MO": "VoiceParticipantItem.module__participantRow___WjZPaj",
  "Kq": "VoiceParticipantItem.module__participantRowSpeaking___WjZPaj",
  "JN": "VoiceParticipantItem.module__participantRowDragging___WjZPaj",
  "z": "VoiceParticipantItem.module__participantRowCurrentConnection___WjZPaj",
  "B$": "VoiceParticipantItem.module__participantRowPopoutOpen___WjZPaj",
  "K0": "VoiceParticipantItem.module__participantRowContextMenuActive___WjZPaj",
  "Kt": "VoiceParticipantItem.module__deviceIcon___WjZPaj",
  "iY": "VoiceParticipantItem.module__deviceIconSpeaking___WjZPaj",
  "ns": "VoiceParticipantItem.module__deviceIconCurrent___WjZPaj",
  "zc": "VoiceParticipantItem.module__iconContainer___WjZPaj",
  "F8": "VoiceParticipantItem.module__participantName___WjZPaj",
  "xr": "VoiceParticipantItem.module__participantNameSpeaking___WjZPaj",
  "S$": "VoiceParticipantItem.module__participantNameCurrent___WjZPaj",
  "_q": "VoiceParticipantItem.module__iconsContainer___WjZPaj",
  "nt": "VoiceParticipantItem.module__flexShrinkZero___WjZPaj",
};

module.exports = exports;
